export function convertPointToRealWorld(e) {
    const stage = e.target.getStage();
    if (!stage) return null;
  
    const pointer = stage.getPointerPosition();
    if (!pointer) return null;
  
    // Find the topmost transformed parent (your camera Group)
    const node = e.target;
  
    const transform = node.getAbsoluteTransform().copy();
    transform.invert();
  
    return transform.point(pointer);
  }